import type { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export const isParticipantV3enabled = (flowAPI: ControllerFlowAPI) => {
  return flowAPI.experiments.enabled('specs.programs.OOIParticipantV3');
};
